export const BUSINESS = {
  name: 'Star Solar Specialists',
  phone: '812-913-0867',
  phoneTel: 'tel:+18129130867',
  email: 'info@starsolarspecialists.com',
  address: '509 Ohio Avenue',
  city: 'Jeffersonville',
  state: 'IN',
  zip: '47130',
  fullAddress: '509 Ohio Avenue, Jeffersonville, IN 47130',
  founded: '2015',
  hours: 'Monday – Friday  |  9:00 AM – 5:00 PM',
  consultationUrl: 'https://meetings.hubspot.com/starsolarspecialists/solarpowerconsultation',
  logo: 'https://starsolarspecialists.com/wp-content/uploads/2020/04/Star-Solar-Logo-1.png',
  social: {
    facebook: 'https://www.facebook.com/starsolarspecialists/',
    twitter: 'https://twitter.com/StarSolarSpec',
    instagram: 'https://www.instagram.com/starsolarspecialists/',
    youtube: 'https://youtube.com/@starsolarspecialists',
  },
};

export const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', label: 'Licensed & Insured', sub: 'Indiana & Kentucky' },
  { icon: 'ri-home-gear-line', label: 'Family Owned', sub: 'Since 2015' },
  { icon: 'ri-star-line', label: 'Serving Kentuckiana', sub: 'Southern IN + N. Central KY' },
  { icon: 'ri-percent-line', label: '30% Federal Tax Credit', sub: 'Available Now' },
  { icon: 'ri-leaf-line', label: 'Residential & Commercial', sub: 'All System Sizes' },
];

export const SERVICE_AREAS = [
  'Jeffersonville, IN',
  'New Albany, IN',
  'Clarksville, IN',
  'Sellersburg, IN',
  'Scottsburg, IN',
  'Corydon, IN',
  'Seymour, IN',
  'Columbus, IN',
  'Louisville, KY',
  'Shelbyville, KY',
  'Frankfort, KY',
  'Georgetown, KY',
  'Elizabethtown, KY',
  'Bardstown, KY',
  'La Grange, KY',
  'Shepherdsville, KY',
];

export const FAQS = [
  {
    question: 'Who provides solar installation near Jeffersonville, IN?',
    answer: 'Star Solar Specialists is a locally licensed, family-owned solar installation company based in Jeffersonville, IN. We serve all of Southern Indiana and North Central Kentucky, including the greater Louisville metro area, and have been installing solar systems since 2015.',
  },
  {
    question: 'How much does solar installation cost in Southern Indiana?',
    answer: 'The cost of a solar power system depends on your home\'s size and energy usage. However, homeowners currently qualify for a 30% federal tax credit that significantly reduces the upfront investment. We offer free estimates — contact us and we\'ll design a custom system with a full cost breakdown.',
  },
  {
    question: 'How long does solar installation take?',
    answer: 'Most residential solar installations are completed within one to three days on-site, after permits are approved. The full process from consultation to grid connection typically takes four to eight weeks, depending on permit timelines and utility interconnection schedules.',
  },
  {
    question: 'Can businesses go solar in North Central Kentucky?',
    answer: 'Yes. Star Solar Specialists installs commercial solar systems for businesses of all sizes across North Central Kentucky and Southern Indiana. Businesses can save 30% via the federal investment tax credit and depreciate up to 85% of the installation cost, making solar an excellent business investment.',
  },
  {
    question: 'How much can I save by switching to solar in Kentuckiana?',
    answer: 'Homeowners in the Kentuckiana region typically eliminate or significantly reduce their monthly electricity bills after going solar. With the 30% federal tax credit currently available, combined with rising utility rates, most homeowners see a strong return on investment within 7 to 10 years.',
  },
  {
    question: 'Does Star Solar Specialists install battery storage systems?',
    answer: 'Yes, we offer battery storage solutions alongside our solar installations. Battery backup systems give you energy independence and protection from grid outages. Ask about battery storage options when you schedule your free consultation.',
  },
  {
    question: 'Is Star Solar Specialists licensed in both Indiana and Kentucky?',
    answer: 'Yes. Star Solar Specialists holds active contractor licenses in both Indiana and Kentucky, making us one of the only Kentuckiana-based solar companies fully authorized to install in both states. We carry full liability insurance and handle all local permitting on your behalf.',
  },
];

export const PROCESS_STEPS = [
  {
    number: '01',
    title: 'Free Consultation',
    description: 'We analyze your property, energy usage, and financial goals to design the ideal solar system for your needs.',
  },
  {
    number: '02',
    title: 'Custom System Design',
    description: 'Our engineers create a tailored solar system design optimized for maximum energy production and ROI for your specific roof and location.',
  },
  {
    number: '03',
    title: 'Permitting & Approvals',
    description: 'We handle all permits, utility applications, and paperwork — so you never have to deal with the bureaucracy.',
  },
  {
    number: '04',
    title: 'Professional Installation',
    description: 'Our licensed installation crew installs your system efficiently, typically completing most residential projects in 1–3 days.',
  },
];

export const WHY_ITEMS = [
  {
    icon: 'ri-map-pin-line',
    title: 'Proudly Local',
    description: 'Based in Jeffersonville, IN — we\'re your neighbors. We understand Kentuckiana\'s climate, utilities, and permitting better than any out-of-state installer.',
  },
  {
    icon: 'ri-verified-badge-line',
    title: 'Licensed in Both States',
    description: 'Professionally licensed and insured to install solar power systems in both Indiana and Kentucky — one trusted team for the entire Kentuckiana region.',
  },
  {
    icon: 'ri-family-line',
    title: 'Family Owned Since 2015',
    description: 'We\'re not a franchise or national chain. We\'re a family-owned business that treats every customer like a neighbor — because they are.',
  },
  {
    icon: 'ri-service-line',
    title: 'End-to-End Service',
    description: 'From consultation and design to permitting, installation, and post-install support — we manage every step of your solar journey.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Homes, Businesses & Nonprofits',
    description: 'We specialize in residential, commercial, and nonprofit solar installations — with tailored financing and incentive strategies for each.',
  },
];
